import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as emailCampaignsApi from '../../api/emailCampaigns';

// Organization setup and activation
export const useSetupOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: emailCampaignsApi.setupOrganization,
    onSuccess: (data, variables) => {
      // Invalidate and refetch organization data
      queryClient.invalidateQueries({
        queryKey: ['organization', variables.organization_id],
      });
    },
    onError: (error) => {
      console.error('Error setting up organization:', error);
      throw error;
    },
  });
};

export const useAuthenticateDomain = () => {
  return useMutation({
    mutationFn: emailCampaignsApi.authenticateDomain,
    onError: (error) => {
      console.error('Error authenticating domain:', error);
    },
  });
};

interface UpdateSenderVariables {
  organizationId: string;
  reply_to_email: string;
}

export const useUpdateSender = () => {
  return useMutation({
    mutationFn: ({ organizationId, reply_to_email }: UpdateSenderVariables) =>
      emailCampaignsApi.updateSender(organizationId, reply_to_email),
    onError: (error) => {
      console.error('Error updating sender:', error);
    },
  });
};

export const useActivateOrganizationCampaigns = () => {
  return useMutation({
    mutationFn: emailCampaignsApi.activateOrganizationCampaigns,
    onSuccess: () => {},
    onError: (error) => {
      console.error('Error activating organization campaigns:', error);
    },
  });
};

export const useDeactivateOrganizationCampaigns = () => {
  return useMutation({
    mutationFn: emailCampaignsApi.deactivateOrganizationCampaigns,
    onSuccess: () => {},
    onError: (error) => {
      console.error('Error deactivating organization campaigns:', error);
    },
  });
};

export const useScheduleCampaign = () => {
  return useMutation({
    mutationFn: emailCampaignsApi.scheduleCampaign,
    onSuccess: () => {},
    onError: (error) => {
      console.error('Error scheduling campaign:', error);
    },
  });
};

export const useTestTemplate = () => {
  return useMutation({
    mutationFn: emailCampaignsApi.testTemplate,
    onSuccess: () => {},
    onError: (error) => {
      console.error('Error testing template:', error);
    },
  });
};
